import { H4 } from '../typography'
import './Card.css'
import cx from 'classnames'

export function CardTitle({ title }: { title: React.ReactNode }) {
  return <H4>{title}</H4>
}

export function CardHeader({
  children,
  className
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <header
      className={cx(
        'card-header',
        'card-header-default',
        'card-header-subtle',
        'card-header-warning',
        className
      )}
    >
      {children}
    </header>
  )
}

export function CardBody({
  children,
  className
}: {
  children: React.ReactNode
  className?: string
}) {
  return <div className={cx('card-body', className)}>{children}</div>
}

export function Card({
  id,
  children,
  className,
  variant = 'default'
}: {
  id?: string
  children: React.ReactNode
  className?: string
  variant?: 'default' | 'subtle' | 'warning'
}) {
  return (
    <div id={id} className={cx('card-base group', className, `variant-${variant}`)}>
      {children}
    </div>
  )
}
